import { render } from "./HeroiconsSolidPaperAirplane.vue?vue&type=template&id=10f7745a"
const script = {}

import exportComponent from "/home/omid_es327/Projects/mohovers/dev/dev-laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPaperAirplane.vue"]])

export default __exports__